import { generateCopy } from '../utils/generateCopy';
import copyJSON from './copy.json';

export const Copy = generateCopy(copyJSON);
